
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useSelector } from 'react-redux';

const handleDragStart = (e) => e.preventDefault();

const styles = {
  containerBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px",
    paddingTop: "1px",
  },
  images: {
    width: "100vw",
    height: "200px",
  },
};


function Carrousel() {

  const account = useSelector((state) => state.account);

  const randomQueryString = Math.random().toString(36).substring(7);
  const PzBanner1 = `${process.env.PUBLIC_URL}/assets/Banners-frontales/Banners-web-B2B_01.jpg?${randomQueryString}`;
  const PzBanner2 = `${process.env.PUBLIC_URL}/assets/Banners-frontales/Banners-web-B2B_02.jpg?${randomQueryString}`;
  const PzBanner3 = `${process.env.PUBLIC_URL}/assets/Banners-frontales/Banners-web-B2B_03.jpg?${randomQueryString}`;
  const PzBanner4 = `${process.env.PUBLIC_URL}/assets/Banners-frontales/Banners-web-B2B_04.jpg?${randomQueryString}`;
  const PzBanner5 = `${process.env.PUBLIC_URL}/assets/Banners-frontales/Banners-web-B2B_05.jpg?${randomQueryString}`;

  const items = [
    <img alt="Banner" style={styles.images} src={PzBanner1} onDragStart={handleDragStart} role="presentation" />,
    <img alt="Banner" style={styles.images} src={PzBanner2} onDragStart={handleDragStart} role="presentation" />,
    <img alt="Banner" style={styles.images} src={PzBanner3} onDragStart={handleDragStart} role="presentation" />,
    <img alt="Banner" style={styles.images} src={PzBanner4} onDragStart={handleDragStart} role="presentation" />,
    <img alt="Banner" style={styles.images} src={PzBanner5} onDragStart={handleDragStart} role="presentation" />,
  ];



  return (
    Object.keys(account.salesData).length === 0 && <AliceCarousel
      mouseTracking
      autoPlayStrategy="none"
      autoPlayInterval={5000}
      animationDuration={4000}
      items={items}
      infinite autoPlay
      autoWidth
      disableButtonsControls
      disableDotsControls />
  );
}

export default Carrousel;
